import React from 'react';
import { string, node } from 'prop-types';

import { Box, BoxWrapper } from './styled';

const OnboardingLayoutBox = ({ children, theme }) => {
  return (
    <BoxWrapper>
      <Box theme={theme} alignSelf="center">
        {children}
      </Box>
    </BoxWrapper>
  );
};

OnboardingLayoutBox.propTypes = {
  theme: string,
  children: node.isRequired,
};

OnboardingLayoutBox.defaultProps = {
  theme: 'light',
};

export default OnboardingLayoutBox;
